import { Layout as AntLayout, Col, Menu, Row } from 'antd';
import { ReactComponent as LogoHorizontal2 } from '../../assets/LOGO_2.svg';
import { ReactComponent as LogoHorizontal } from '../../assets/LogoHorizontal.svg';

import { useMediaQuery } from 'shared/utils';
import styled from 'styled-components';
import { ReactComponent as Home } from '../../assets/Home.svg';
import { ReactComponent as Home2 } from '../../assets/Home2.svg';

const { Header: AntHeader } = AntLayout;

const HeaderAnt = styled(({ ...rest}) => <AntHeader {...rest}/>)`
  background: ${({ background }) => background};

  .ant-menu-horizontal > .ant-menu-item::after,
  .ant-menu-horizontal > .ant-menu-submenu::after {
    bottom: 10px;
    border-radius: 40px;
  }

  .ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item:hover::after,
  .ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-submenu:hover::after,
  .ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item-active::after,
  .ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-submenu-active::after,
  .ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item-open::after,
  .ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-submenu-open::after,
  .ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item-selected::after,
  .ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-submenu-selected::after {
    border-bottom: 3px solid #ff1744;
  }

  .ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item:hover,
  .ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-submenu:hover,
  .ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item-active,
  .ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-submenu-active,
  .ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item-open,
  .ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-submenu-open,
  .ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item-selected,
  .ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-submenu-selected {
    color: #3742fa;
  }

  .ant-menu-horizontal > .ant-menu-item-selected a {
    color: #3742fa !important ;
  }
    .logo-header {
      width: 160px;
      padding-top: 10px
    }
    @media (max-width: 940px) {
      .logo-header {
        width: 120px;
      padding-top: 0px
      }
    }
    @media (max-width: 608px) {
      .logo-header {
      padding-top: 0px
      }
    }
`;

const Header = ({background= "#ffffff", color = '#1E3799', icon, home="blue"}) => {
  const isDesktop = useMediaQuery('(min-width: 609px)');
  return (
    <HeaderAnt background={background }>
      <Row style={{ margin: 'auto', maxWidth: '1440px', height: "100%" }}>
        <Col
          xs={16}
          sm={12}
          md={12}
          lg={6}
          xl={6}
          xxl={6}
          style={{
            display: "grid",
            alignContent: "center",
          }}>
          {icon ? <LogoHorizontal2 className='logo-header' />: <LogoHorizontal className='logo-header'   />}
        </Col>
        {isDesktop && (
          <>
            <Col xs={8} sm={12} md={12} lg={18} xl={18} xxl={18}>
              <Menu
                mode='horizontal'
                defaultSelectedKeys={['1']}
                style={{ borderBottom: '0px', justifyContent: 'end', fontWeight: '500', fontFamily: '"Roboto", sans-serif', color: color, fontSize: '16px', paddingTop: '9px', background: background }}>
                <Menu.Item key='1'>
                  <a href='#Home'>
                    {
                      home === "white" ? <Home style={{ color: color, width: "20px", height: "20px",  }} />
                      :
                    <Home2 style={{ color: color, width: "20px", height: "20px",  }} />
                    }
                    
                  </a>
                </Menu.Item>
                <Menu.Item key='2'>
                  <a href='#iCancha' style={{ color: color }}>
                    iCancha
                  </a>
                </Menu.Item>
                <Menu.Item key='3'>
                  <a href='#Centro-Deportivo' style={{ color: color }}>
                    Soy un Centro Deportivo
                  </a>
                </Menu.Item>
                {/*<Menu.Item key="4">
                            FAQ´s
                        </Menu.Item>*/}
                <Menu.Item key='5'>
                  <a href={process.env.REACT_APP_REDIRECT_SARI} target='_blank' rel='noreferrer' style={{ color: color }}>
                    Ingresa a SARi
                  </a>
                </Menu.Item>
              </Menu>
            </Col>
          </>
        )}

      </Row>
    </HeaderAnt>
  );
};

export default Header;
